import polyglotI18nProvider from 'ra-i18n-polyglot';

import { englishMessages } from '../i18n/en';
import { hebrewMessages } from '../i18n/he';
import { spanishMessages } from '../i18n/es';
import { portugeuseMessages } from '../i18n/pt';
import { italianMessages } from '../i18n/it';

export type Lang = 'he' | 'en' | 'es' | 'pt' | 'it';

export const translators: { [key: string]: any } = {
	'en': englishMessages,
	'he': hebrewMessages,
	'pt': portugeuseMessages,
	'es': spanishMessages,
	'it': italianMessages
};

export const i18nProvider = polyglotI18nProvider(locale => {
		return translators[locale];
	},
	'en'
);
